import React from "react";
import { nanoid } from "nanoid";
import SocketServices from "../../utils/socket.services";
import { checkTextTranslation, checkTranslation, getOneThing, imageAddress } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from '../../stores/actionsList';
import moment from "jalali-moment";


class LogsWidget extends React.Component {

    state = {
        data: [],
        baseHeaders: [
            { key: 'cDate', type: 'DateInput', information: { label: '{{lang}}date', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertName', required: true } },

        ],

        data: [
            { activity: 'create', title: 'This is the title of the log', message: 'This is a test message as a log' },
            { activity: 'create', title: 'New Project created', message: 'A new project has been created by Pouya Pezhman' },
            { activity: 'update', title: 'Task status updated', message: 'The status of the task #T-3112 has been updated' },
            { activity: 'update', title: 'Task status updated', message: 'The status of the task #T-1495 has been updated' },
            { activity: 'delete', title: 'Task removed', message: 'Task #T-1495 has been removed' },


        ],

        topicId: nanoid(10)
    }




    componentDidMount() {
        this.main.addEventListener('wheel', this.onWheel, true)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.data?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        SocketServices.removeTopic(this.state.topicId, this.props.data?.thing, 'things')
        this.main.removeEventListener('wheel', this.onWheel)

    }

    init() {

        this.setState({ thing: {}, data: [] }, () => {
            getOneThing({ id: this.props.data.thing }, (fetchResult, fetchError, status) => {
                // console.log(fetchResult)
                if (fetchResult) {
                    this.setState({ thing: fetchResult.info }, () => {


                        let headers = [...this.state.baseHeaders]
                        if (Array.isArray(this.props.data.characteristic)) {
                            this.props.data.characteristic.forEach(element => {

                                headers.push({ key: "data." + element, type: 'TextInput', information: { label: this.getLabel(element) } })

                            });
                            this.setState({ headers })
                        }

                        this.fetchList()
                    })
                }
            })
        })
    }




    fetchList = () => {

        let limit = 25
        if (this.props.data.limit) {
            limit = Number(this.props.data.limit)
        }

        // console.log("this.props.dashboard")

        // console.log(this.props.dashboard)
        HttpServices.request("getThingHistory", { filter: { thing: this.props.data.thing, }, dashboard: this.props.dashboard?._id, limit }, (fetchResult, fetchError, status) => {
            SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)
            console.log(fetchResult)
            if (fetchError) { return }

            this.setState({ data: fetchResult.info })
            // if (cb) { cb(fetchResult, null, status) }
        })
    }






    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }
    openOne = (item) => {
        console.log('item')
    }

    updateData = (newData) => {
        let data = this.state.data
        data.splice(0, 0, { cDate: new Date(), data: newData })
        // data = { ...data, ...newData }
        this.setState({ data })
        // console.log("updateData")
    }

    onWheel = (e) => {
        // console.log(e)
        e.stopPropagation()
    }



    render() {
        return (
            <div ref={el => this.main = el} className="w-100 dashboard-widgets h-100 d-flex flex-column" style={{ minHeight: 300, maxHeight: 400, height: '100%' }} >
                {/* <div style={{ position: 'absolute', top: 40, backgroundColor: '#ffffffee', padding: '3px 20px', borderRadius: '4px 4px 0px 0px' }}>
                    <p style={{ color: '#9ab', fontSize: 12 }}>Listed Data count {this.state.data?.length}</p>
                </div> */}

                <div className=' pt-3 flexc position-sticky pb-2 px-3'>
                    <p className='text-bold text-normal '>Activity Log</p>
                </div>

                {!this.state.data?.length && (
                    <div className="flexcc flex-column px-3 pb-4">
                        <img className="w-50 mt-2" src="/assets/updates.jpg" />
                        <p className="text-semibold semibig">No Activity Yet</p>
                        <p className='text-muted text-smaller mt-2' style={{ maxWidth: 390 }}>Here you can see the newest activity logs. This helps you to be updated about all the notifications and required actions.</p>

                    </div>
                )}
                <div className="w-100 px-3 flex-1 pb-2" style={{ left: 0, width: '100%', overflow: 'auto' }}>

                    {this.state.data.map((item, index) => {
                        let image
                        let bgColor
                        if (item.activity == 'create') {
                            image = '/assets/icons/add-log.svg'
                            bgColor = '#34c759'
                        }
                        if (item.activity == 'update') {
                            image = '/assets/icons/update-log.svg'
                            bgColor = '#007aff'
                        }
                        if (item.activity == 'delete') {
                            image = '/assets/icons/delete-log.svg'
                            bgColor = '#ff3b30'
                        }
                        return (
                            <div className="d-flex flexc w-100">
                                <div className="d-flex  connect-selection px-3  br-10 w-100">
                                    <div className="flexc flex-column ">
                                        <div style={{ borderRight: index > 0 ? "1px dashed #C3C3C3" : null, width: "1px", flex: 1, margin: "auto", marginTop: '2px' }}></div>
                                        <div className="flexcc" style={{ background: bgColor, borderRadius: '50%' }}>
                                            <img className="br-50" style={{ objectFit: "cover", width: "40px", height: "40px", }} src={image} />
                                        </div>
                                        <div style={{ borderRight: "1px dashed #C3C3C3", width: "1px", flex: 1, margin: "auto" }}></div>
                                    </div>
                                    <div className="mld-4 py-3">
                                        <div className="d-flex flex-column">
                                            <div className="flexc">
                                                <p className="font-size-14 weight-700">{item.title}</p>
                                            </div>
                                            <div className="flexc mt-1">
                                                <p className="font-size-12">{item.message}</p>
                                            </div>
                                            <div className="flexc mt-1">
                                                <p className="font-size-12">{moment(item.cDate).locale('en').format('DD-MMMM-YYYY')}</p>
                                            </div>

                                            <div className="flexc mt-1">
                                                <img src={imageAddress('', 'profile', 'thumb')} className="br-20 " style={{ width: 20, height: 20 }} />
                                                <p className="font-size-12 mx-1">Name Family</p>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        );
                    })}
                </div>

            </div >
        )
    }
}



// export default LogsWidget;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogsWidget);
